import { StoryblokServerComponent, storyblokEditable } from '@storyblok/react/rsc'
import Stack from '@audioeye-marketing/ui/src/components/Stack'
import Box from '@audioeye-marketing/ui/src/components/Box'
import Frame from '@/components/storyblok/global/Frame'
import TableOfContents from '@/components/misc/TableOfContents'

const Guide = async ({ blok, rels }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <Frame blok={blok?.frame?.content} rels={rels}>
        <Box sx={{ borderBottom: '1px solid var(--joy-palette-divider)' }}>
          {blok?.hero?.map((currentSection) => (
            <StoryblokServerComponent
              blok={currentSection}
              key={currentSection?._uid}
              rels={rels}
              headingLevel={1}
              imagePriority
            />
          ))}
        </Box>
        <Stack direction={{ xs: 'column', lg: 'row' }}>
          {/* Mobile Secondary Navigation */}
          {blok?.secondary_navigation?.map((currentSection) => (
            <StoryblokServerComponent
              blok={currentSection}
              key={currentSection?._uid}
              rels={rels}
              sx={{ display: { xs: 'block', lg: 'none' } }}
              padding="md"
            />
          ))}
          <TableOfContents
            pageData={blok}
            eyebrowHeadings={blok?.eyebrow_headings}
            constraint={!blok?.body?.[0]?.component?.includes('Rich Text Content') ? 'lg' : 'sm'}
            sx={{
              maxWidth: { xs: '100%', lg: '328px' },
              pl: { xs: 3, sm: !blok?.body?.[0]?.component?.includes('Rich Text Content') ? 8 : 5, lg: 7.5 },
              top: { xs: 0, lg: '40px' },
            }}
          />
          <Box sx={{ width: '100%', borderLeft: { xs: 'none', lg: '1px solid var(--joy-palette-divider)' } }}>
            {/* Desktop Secondary Navigation */}
            {blok?.secondary_navigation?.map((currentSection) => (
              <StoryblokServerComponent
                blok={currentSection}
                key={currentSection?._uid}
                rels={rels}
                sx={{ display: { xs: 'none', lg: 'block' } }}
                padding="md"
              />
            ))}

            {blok?.body?.map((currentSection, index) => (
              <StoryblokServerComponent
                blok={currentSection}
                key={currentSection?._uid}
                rels={rels}
                headingLevel={2}
                imagePriority={index === 0}
                padding="md"
              />
            ))}
          </Box>
        </Stack>
      </Frame>
    </div>
  )
}

export default Guide
